<template>
  <v-row
    dense
    align="start"
  >
    <v-col
      cols="12"
      lg="3"
    >
      <v-select
        v-model="dateRange"
        :items="dateRangeItems"
        item-text="label"
        item-value="range"
        label="Select"
        persistent-hint
        return-object
        single-line
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <v-select
        v-model="statsShowStyle"
        :items="statsShowStyleItems"
        item-text="label"
        item-value="style"
        label="Select"
        persistent-hint
        return-object
        single-line
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <v-select
        v-model="statsShowSet"
        :items="statsShowSetItems"
        item-text="label"
        item-value="set"
        label="Select"
        persistent-hint
        return-object
        single-line
      />
    </v-col>
    <v-col
      v-if="participantReportingReports"
      cols="12"
    >
      <LineChart :chart-data="participantReportingReportsChartData" />
    </v-col>
  </v-row>

</template>

<script>
  import gql from 'graphql-tag'
  import LineChart from '../../components/LineChart.vue';
  import TenantMixin from "@/mixins/TenantMixin";
  import { date3MonthsAgo, date14DaysAgo, date30DaysAgo, date6MonthsAgo, dateThisYearStart, dateLastYearStart, dateLastYearEnd, getISOWeekNumber } from '../../utils/dates';
  import AuthenticationMixin from '../../mixins/AuthenticationMixin';

  export default {
    name: 'BookingReporting',
    mixins: [AuthenticationMixin, TenantMixin],
    components: {
      LineChart
    },
    data: () => ({
      statsShowStyle: { label: 'pro Tag', style: 1 },
      statsShowStyleItems: [
        { label: 'pro Tag', style: 1 },
        { label: 'pro Woche', style: 2 },
        { label: 'pro Monat', style: 3 },
        { label: 'pro Jahr', style: 4 },
      ],
      statsShowSet: { label: 'Buchungen', set: 1 },
      statsShowSetItems: [
        { label: 'Buchungen', set: 1 },
        { label: 'Umsatz', set: 2 },
      ],
      dateRange: { label: '3 Monate', range: { after: date3MonthsAgo() } },
    }),
    computed: {
      currentTenantColor() {
        if (this.userData.activeTenant) {
          const companySettings = this.getCompanySettings(this.userData.activeTenant);
          if (companySettings && companySettings.color) {
            return companySettings.color;
          }
        }
        return '#ff00cc';
      },
      dateRangeItems() {
        return [
          { label: '14 Tage', range: { after: date14DaysAgo() } },
          { label: '30 Tage', range: { after: date30DaysAgo() } },
          { label: '3 Monate', range: { after: date3MonthsAgo() } },
          { label: '6 Monate', range: { after: date6MonthsAgo() } },
          { label: 'dieses Jahr', range: { after: dateThisYearStart() } },
          { label: 'letztes Jahr', range: { after: dateLastYearStart(), before: dateLastYearEnd() } },
          { label: 'alle', range: null },
        ]
      },
      participantReportingReportsChartData() {
        const labels = [];
        const dataBookingCount = [];
        const dataBookingSalesValue = [];

        if (!this.participantReportingReports) {
          return null;
        }

        this.participantReportingReports.forEach((report) => {
          const reportDate = new Date(report.createdAt);
          let label = null;

          switch (this.statsShowStyle.style) {
            case 1: // per day
              {
                const day = String(reportDate.getDate()).padStart(2, '0');
                const month = String((reportDate.getMonth() +1)).padStart(2, '0');
                const year = reportDate.getFullYear();
                label = `${day}.${month}.${year}`;
              }
              break;
            case 2: // per week
              {
                label = `KW ${getISOWeekNumber(reportDate)}`;
              }
              break;
            case 3: // per month
              {
                const month = String(reportDate.getMonth()).padStart(2, '0');
                const year = reportDate.getFullYear();
                label = `${month}.${year}`;
              }
              break;
            case 4: // per year
              {
                label = `${reportDate.getFullYear()}`;
              }
              break;
          }

          if (!labels.includes(label)) {
            labels.push(label);
            dataBookingCount.push(1);
            dataBookingSalesValue.push(report.orderValueTotal);
          } else {
            const index = labels.indexOf(label);
            dataBookingCount[index] += 1;
            dataBookingSalesValue[index] += report.orderValueTotal;
          }
        });

        return {
          labels,
          datasets: [
            (this.statsShowSet.set === 1) ? {
              label: 'Buchungen',
              backgroundColor: this.currentTenantColor,
              data: dataBookingCount,
            } : {
              label: 'Umsatz',
              backgroundColor: this.currentTenantColor,
              data: dataBookingSalesValue,
            },
          ]
        };
      }
    },
    apollo: {
      participantReportingReports() {
        return {
          query: gql`
            query participantReportingReports($dateRange: [ParticipantReportingReportFilter_createdAt]) {
              participantReportingReports(createdAt: $dateRange){
                id
                orderValueTotal
                createdAt
              }
            }
          `,
          variables() {
            return {
              dateRange: [
                this.dateRange.range
              ]
            }
          },
          context: {
            headers: {
              authorization: this.$store.state.authentication.loggedIn ? `Bearer ${this.$store.state.authentication.token}` : ''
            }
          }
        }
      },
    },
  };
</script>
